// Figma frame 01 sign in (33:308). US-080.

import { AuthShell } from "./AuthShell";
import { EmailRequestForm } from "./EmailRequestForm";

export type SigninScreenProps = {
  onSent: (email: string) => void;
};

export function SigninScreen({ onSent }: SigninScreenProps) {
  return (
    <AuthShell>
      <h1 className="maisight-signin-heading type-h2">Sign in</h1>
      <p className="maisight-signin-body type-bodyS">
        We&rsquo;ll email you a link. No password to forget.
      </p>
      <EmailRequestForm
        submitLabel="Email me a link"
        pendingLabel="Sending…"
        help="Use the address your team's docs account is on."
        onSuccess={onSent}
      />
    </AuthShell>
  );
}
